var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeName == 'index')?_c('Index'):_vm._e(),_vm._v(" "),(_vm.activeName == 'equip')?_c('Equip'):_vm._e(),_vm._v(" "),(_vm.activeName == 'log')?_c('Log'):_vm._e(),_vm._v(" "),(_vm.activeName == 'cash')?_c('Cash'):_vm._e(),_vm._v(" "),(_vm.activeName == 'role')?_c('Role'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7a46b9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/service/index.vue
// module id = null
// module chunks = 